import React, { useEffect, useState } from 'react';

const defaultStyles = `
:root{ --gradient: linear-gradient(135deg,#DC143C 0%,#8B0000 100%); --shadow: 0 8px 25px rgba(220,20,60,.15); --primary:#DC143C; --secondary:#8B0000; --primary-light:#FF6B6B; --primary-dark:#8B0000; --primary-subtle:rgba(220,20,60,0.1); font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif; }
html,body{ margin:0; padding:0; background: linear-gradient(135deg,#f6f8fa 0%, rgba(220,20,60,0.02) 100%); min-height:100vh; }
#panel{ width:100%; height:100vh; background:#fff; display:flex; flex-direction:column; overflow:hidden; }
.drag-bar{ height:24px; background:linear-gradient(180deg,#f8f8f8 0%,#e8e8e8 100%); border-bottom:1px solid #d0d0d0; -webkit-app-region:drag; user-select:none; flex-shrink:0; cursor:move; }
.content-wrapper{ flex:1; padding:15px 20px 12px; display:flex; flex-direction:column; overflow-y:auto; }
.content-wrapper::-webkit-scrollbar{ width:8px; }
.content-wrapper::-webkit-scrollbar-track{ background:#f1f1f1; border-radius:4px; }
.content-wrapper::-webkit-scrollbar-thumb{ background:linear-gradient(180deg,var(--primary-light) 0%,var(--primary) 100%); border-radius:4px; }
.content-wrapper::-webkit-scrollbar-thumb:hover{ background:var(--primary); }
.title-header{ display:flex; align-items:center; justify-content:space-between; margin:0 0 5px 0; padding:0; }
.title-header h1{ margin:0; font-size:1.3rem; background:linear-gradient(135deg,#DC143C 0%,#B22222 50%,#8B0000 100%); -webkit-background-clip:text; -webkit-text-fill-color:transparent; font-weight:700; letter-spacing:-0.5px; flex-shrink:0; }
.title-buttons{ display:flex; gap:8px; align-items:center; }
.title-buttons button{ padding:4px 12px; border:none; border-radius:16px; font-size:0.8rem; font-weight:500; cursor:pointer; transition:all 0.2s; height:28px; }
.title-buttons #save{ background:var(--primary); color:white; }
.title-buttons #save:hover{ background:var(--primary-dark); transform:translateY(-1px); }
.title-buttons #save:disabled{ opacity:.6; cursor:not-allowed; transform:none; }
.title-buttons #reset{ background:#e1e4e8; color:#586069; }
.title-buttons #reset:hover{ background:#d1d5da; color:var(--primary-dark); }
.title-buttons #close{ background:transparent; color:#586069; border:1px solid #e1e4e8; }
.title-buttons #close:hover{ border-color:rgba(220,20,60,0.3); background:rgba(220,20,60,0.05); color:var(--primary); }
.shortcuts-container{ overflow-y:auto; margin:10px 0; flex:1; min-height:0; }
.shortcuts-container::-webkit-scrollbar{ width:8px; }
.shortcuts-container::-webkit-scrollbar-track{ background:#f1f1f1; border-radius:4px; }
.shortcuts-container::-webkit-scrollbar-thumb{ background:linear-gradient(180deg,var(--primary-light) 0%,var(--primary) 100%); border-radius:4px; }
.shortcuts-container::-webkit-scrollbar-thumb:hover{ background:var(--primary); }
table{ width:100%; border-collapse:collapse; font-size:.85rem; }
th,td{ padding:8px 6px; vertical-align:middle; }
th{ text-align:left; font-weight:600; color:#2c3e50; border-bottom:2px solid var(--primary-light); background:linear-gradient(180deg,#fafafa 0%,#f3f3f3 100%); position:sticky; top:0; text-transform:uppercase; font-size:.8rem; letter-spacing:.5px; }
tr{ transition:background-color .2s ease; }
tr:not(:last-child) td{ border-bottom:1px solid rgba(220,20,60,0.08); }
tr:hover td{ background:rgba(220,20,60,0.02); }
td.desc{ color:#2c3e50; width:60%; font-weight:500; }
.shortcut-input{ width:100%; padding:6px 10px; border:2px solid #e1e4e8; border-radius:6px; font-family:Menlo,Consolas,monospace; font-size:.85rem; font-weight:600; text-align:center; background:#f6f8fa; color:#2c3e50; transition:all 0.2s; }
.shortcut-input:hover:not(.recording){ border-color:rgba(220,20,60,0.3); }
.shortcut-input:focus{ outline:none; border-color:var(--primary); background:#fff; box-shadow:0 0 0 3px rgba(220,20,60,0.1); }
.shortcut-input.recording{ border-color:#FF6B6B; background:rgba(255,107,107,0.1); animation:pulse 1s infinite; }
.shortcut-input.error{ border-color:var(--primary-dark); background:rgba(139,0,0,0.1); }
@keyframes pulse{0%{box-shadow:0 0 0 0 rgba(255,107,107,0.4);}70%{box-shadow:0 0 0 6px rgba(255,107,107,0);}100%{box-shadow:0 0 0 0 rgba(255,107,107,0);}}
.status{ text-align:center; margin:10px 0; padding:8px; border-radius:6px; font-size:.85rem; opacity:0; transition:all .3s ease; transform:translateY(-10px); }
.status.show{ opacity:1; transform:translateY(0); }
.status.success{ background:linear-gradient(135deg,rgba(220,20,60,0.1) 0%,rgba(139,0,0,0.1) 100%); color:var(--primary-dark); border:1px solid rgba(220,20,60,0.3); }
.status.error{ background:#f8d7da; color:#721c24; border:1px solid #f5c6cb; }
.section-header{ background:linear-gradient(135deg,rgba(220,20,60,0.1) 0%,rgba(139,0,0,0.1) 100%); padding:6px 12px; margin:10px -6px 4px; border-radius:6px; font-weight:600; color:var(--primary); font-size:.9rem; border-left:3px solid var(--primary); }
.info-section{ margin:0 0 5px 0; flex-shrink:0; }
.config-section{ margin:0 0 15px 0; flex-shrink:0; }
.setting-row{ display:flex; align-items:center; justify-content:space-between; padding:12px 16px; background:linear-gradient(135deg,#fafafa 0%,rgba(220,20,60,0.02) 100%); border-radius:8px; border:1px solid rgba(220,20,60,0.1); margin-bottom:10px; }
.setting-label{ display:flex; flex-direction:column; gap:2px; }
.key-badge{ display:inline-flex; align-items:center; justify-content:center; padding:4px 10px; background:var(--primary); color:white; border-radius:4px; font-family:Menlo,Consolas,monospace; font-size:.85rem; font-weight:600; min-width:35px; cursor:pointer; transition:all 0.2s; border:2px solid transparent; }
.key-badge:hover{ background:var(--primary-dark); transform:scale(1.05); }
.key-badge.recording{ border-color:#fff; animation:pulse 1s infinite; background:#FF6B6B; }
.key-badge.small{ padding:2px 6px; font-size:.75rem; min-width:auto; }
.key-badge.disabled{ opacity:0.6; cursor:default; background:var(--primary-light); }
.plus{ color:#586069; font-weight:600; margin:0 2px; }
.toggle-switch{ position:relative; display:inline-block; width:40px; height:22px; }
.toggle-switch input{ opacity:0; width:0; height:0; }
.toggle-slider{ position:absolute; cursor:pointer; top:0; left:0; right:0; bottom:0; background-color:#ccc; transition:.3s; border-radius:22px; }
.toggle-slider:before{ position:absolute; content:""; height:16px; width:16px; left:3px; bottom:3px; background-color:white; transition:.3s; border-radius:50%; }
input:checked + .toggle-slider{ background-color:#4CAF50; }
input:checked + .toggle-slider:before{ transform:translateX(18px); }
`;

const defaultShortcuts = {
  toggleApp: { key: 'F12', desc: 'Afficher/masquer voxia' },
  toggleRecorder: { key: 'F11', desc: 'Dictaphone: enregistrer' },
  dictationServer: { key: 'F10', desc: 'Dictée Live: enregistrer' },
  toggleRecorderMode: { key: 'F9', desc: 'Dictée Live: changer le modèle' },
  annexCopy:{ key: 'CommandOrControl+Shift+C', desc: 'Ajouter le texte s\u00E9lectionn\u00E9 en annexe' },
  screenshotScreen1:{ key: 'CommandOrControl+Shift+1', desc: 'Capture d\u2019\u00E9cran - \u00C9cran 1' },
  screenshotScreen2:{ key: 'CommandOrControl+Shift+2', desc: 'Capture d\u2019\u00E9cran - \u00C9cran 2' },
  screenshotScreen3:{ key: 'CommandOrControl+Shift+3', desc: 'Capture d\u2019\u00E9cran - \u00C9cran 3' }
};

// Group shortcuts by category
const categories = [
  {
    title: 'Général',
    ids: ['toggleApp', 'toggleRecorderMode']
  },
  {
    title: 'Live',
    ids: ['toggleRecorder', 'dictationServer', 'annexCopy']
  },
  {
    title: 'Capture',
    ids: ['screenshotScreen1', 'screenshotScreen2', 'screenshotScreen3']
  }
];

function HelperWindow() {
  const [shortcuts,setShortcuts] = useState({});
  // autoSelect feature removed
  const [recording,setRecording] = useState(null);
  const [status,setStatus] = useState(null);

  useEffect(() => {
    async function init() {
      const loaded = await window.electronAPI.getShortcuts() || {};
      setShortcuts({ ...defaultShortcuts, ...loaded });
      // autoSelect removed
    }
    init();
  }, []);

  useEffect(() => {
    if (!recording) return;
    const handle = e => {
      e.preventDefault();
      const keys = [];
      if (e.ctrlKey || e.metaKey) keys.push('CommandOrControl');
      if (e.altKey) keys.push('Alt');
      if (e.shiftKey) keys.push('Shift');
      const map = { ' ': 'Space', ArrowUp:'Up', ArrowDown:'Down', ArrowLeft:'Left', ArrowRight:'Right', Enter:'Return', Escape:'Escape', Tab:'Tab', Delete:'Delete', Backspace:'Backspace', Home:'Home', End:'End', PageUp:'PageUp', PageDown:'PageDown' };
      let key = e.key;
      if (e.key.match(/^F\d+$/)) { key = e.key; }
      else if (map[e.key]) { key = map[e.key]; }
      else if (e.key.length === 1) { key = e.key.toUpperCase(); }
      if (['Control','Alt','Shift','Meta','Command'].includes(e.key)) return;
      keys.push(key);
      const sc = keys.join('+');
      setShortcuts(s => ({ ...s, [recording]: { ...s[recording], key: sc } }));
      setRecording(null);
    };
    document.addEventListener('keydown', handle);
    return () => document.removeEventListener('keydown', handle);
  }, [recording]);

  const displayKey = id => (shortcuts[id]?.key || '').replace('CommandOrControl','Ctrl');

  const saveShortcuts = async () => {
    try {
      await window.electronAPI.setShortcuts(shortcuts);
      setStatus({ message:'Param\u00E8tres enregistrés avec succès!', type:'success' });
    } catch (err) {
      setStatus({ message:`Erreur: ${err.message}`, type:'error' });
    }
  };

  const reset = () => {
    setShortcuts({ ...defaultShortcuts });
    // setAutoSelect(true); // autoSelect removed
    setStatus({ message:'Param\u00E8tres r\u00E9initialis\u00E9s', type:'success' });
  };

  const close = () => window.electronAPI?.toggleHelper?.();

  useEffect(() => {
    if(!status) return;
    const t = setTimeout(()=> setStatus(null),3000);
    return () => clearTimeout(t);
  }, [status]);

  useEffect(() => {
    const fa = document.createElement('link');
    fa.rel='stylesheet';
    fa.href='https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css';
    document.head.appendChild(fa);
    return () => document.head.removeChild(fa);
  }, []);

  return (
    <div id="panel">
      <style>{defaultStyles}</style>
      <div className="drag-bar" />
      <div className="content-wrapper">
        <div className="title-header">
          <h1>Dictée Live</h1>
          <div className="title-buttons">
            <button id="save" onClick={saveShortcuts}>Enregistrer</button>
            <button id="reset" onClick={reset}>Reset</button>
            <button id="close" onClick={close}>Fermer</button>
          </div>
        </div>
        {status && <div className={`status ${status.type} show`} id="status">{status.message}</div>}
        <div className="config-section">
          <p style={{color:'#586069',fontSize:'0.9rem',marginBottom:'15px'}}>
            Cliquez sur un raccourci pour le modifier. Pour plus d\'informations détaillées, consultez le guide complet dans l'application.
          </p>
          {/* auto-select setting removed */}
          <div className="shortcuts-container">
            <table>
              <thead>
                <tr><th>Fonction</th><th>Raccourci</th></tr>
              </thead>
              <tbody>
                {categories.map(cat => (
                  <React.Fragment key={cat.title}>
                    <tr><td colSpan={2} className="section-header">{cat.title}</td></tr>
                    {cat.ids.map(id => (
                      <tr key={id}>
                        <td className="desc">{defaultShortcuts[id].desc}</td>
                        <td>
                          <span
                            className={`key-badge${recording===id?' recording':''}`}
                            onClick={()=> setRecording(id)}
                          >
                            {recording===id? 'Appuyez...' : displayKey(id)}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelperWindow;
